// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"58530d35","787":"1e84c086"}[chunkId] + ".chunk.js";
};